import React from 'react'

function Minus ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='12' height='1.091' viewBox='0 0 12 1.091'>
      <path d='M96,202.668h12v1.091H96Zm0,0' transform='translate(-96 -202.668)' />
    </svg>
  )
}

Minus.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Minus
